// extracted by mini-css-extract-plugin
module.exports = {"radioClass":"RadioInputPage_radioClass__3728V","markClass":"RadioInputPage_markClass__3r9cJ","labelClass":"RadioInputPage_labelClass__1EMLS"};